__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell-manager";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@omnipkg/ui-kit-web", "2.2.71", () => (Promise.all([__webpack_require__.e(834), __webpack_require__.e(770), __webpack_require__.e(90), __webpack_require__.e(417), __webpack_require__.e(179)]).then(() => (() => (__webpack_require__(1834))))));
			register("@sentry/react", "7.112.2", () => (Promise.all([__webpack_require__.e(722), __webpack_require__.e(770)]).then(() => (() => (__webpack_require__(4722))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(770)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "6.22.3", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(770), __webpack_require__.e(90)]).then(() => (() => (__webpack_require__(2648))))));
			register("react-slick", "0.30.2", () => (Promise.all([__webpack_require__.e(589), __webpack_require__.e(770)]).then(() => (() => (__webpack_require__(4589))))));
			register("react", "18.2.0", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("styled-components", "6.1.8", () => (Promise.all([__webpack_require__.e(715), __webpack_require__.e(770)]).then(() => (() => (__webpack_require__(4715))))));
			initExternal(8660);
			initExternal(3274);
			initExternal(5053);
			initExternal(1977);
			initExternal(2016);
			initExternal(4311);
			initExternal(2404);
			initExternal(6532);
			initExternal(2928);
			initExternal(5314);
			initExternal(9748);
			initExternal(4644);
			initExternal(751);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};